import React, { useEffect } from 'react';
import { BrannanWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { isInIframe } from '@shared/utils/isInIframe';
import { sendMessageToParentWindow } from '@shared/utils/previewMessageBus';
import { PhotoBackgroundLayout } from '../HeaderV2/layouts';
import { EventNameNavForStandaloneHeaderProps } from '../HeaderV2/components/EventNameNavForStandaloneHeader/EventNameNavForStandaloneHeader';
import { EventPageType } from '@graphql/generated';
import { GuestSiteEventDesign } from '../../../layout.types';

interface StandaloneWebsiteHeaderProps extends EventNameNavForStandaloneHeaderProps {
  websiteHeader: NonNullable<BrannanWebsiteHeaderSettings['websiteHeader']>;
  currentPageType: EventPageType | undefined;
  eventDesign: GuestSiteEventDesign;
}

const isPreview = isInIframe();

export const StandaloneWebsiteHeader = (props: StandaloneWebsiteHeaderProps) => {
  const { websiteHeader, ...restProps } = props;

  const headerPhoto = websiteHeader.headerPhoto;
  const showPlaceholder = isPreview && !!headerPhoto.presentationLayout;

  useEffect(() => {
    if (headerPhoto.presentationLayout) {
      sendMessageToParentWindow({ action: 'requestIframeScaleValue', source: 'joyPreview' });
    }
  }, [headerPhoto.presentationLayout]);

  switch (headerPhoto.presentationLayout) {
    case 'photoBackground':
      return <PhotoBackgroundLayout websiteHeader={{ ...websiteHeader, headerPhoto }} showPlaceholder={showPlaceholder} {...restProps} />;
    default:
      return null;
  }
};

StandaloneWebsiteHeader.displayName = 'StandaloneWebsiteHeader';
